import { post } from '../../../../../api';
import { NewMemberApi } from './AcknowledgePage.types';

export const postMembershipRequest = async (request: NewMemberApi) => {
  await post(request, '/members/new', { ignoreAuthentication: true });
};
